import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UploadFileModule } from '../upload-file/upload-file.module';
import { UploadCropperModule } from '../upload-cropper/upload-cropper.module';
import { UploadManagerModule } from '../upload-manager/upload-manager.module';

import { UploadMediaComponent } from './upload-media.component';
import { SvgIconModule } from '../svg-icon';
import { ExternalVideoManagerModule } from '../external-video-manager/external-video-manager.module';
import { DropDownOptionsModule } from '../drop-down-options/drop-down-options.module';
import { LoadingComponentModule } from '../loading/loading.module';
import { SimpleModalModule } from '../simple-modal/simple-modal.module';
import { InputFormFieldModule } from '../input-form-field/input-form-field.module';

@NgModule({
    declarations: [UploadMediaComponent],
    imports: [
        CommonModule,
        UploadFileModule,
        UploadCropperModule,
        UploadManagerModule,
        SvgIconModule,
        ExternalVideoManagerModule,
        DropDownOptionsModule,
        InputFormFieldModule,
        LoadingComponentModule,
        SimpleModalModule
    ],
    exports: [UploadMediaComponent]
})
export class UploadMediaModule { }
